"use client";

import { InferRequestType, InferResponseType } from "hono";
import { useMutation, useQuery } from "@tanstack/react-query";
import { client } from "@/lib/hono";

const submitEndpoint = client.api.storage["lomda-v3"].responses.$post;
const aggregateEndpoint =
    client.api.storage["lomda-v3"].responses[":blockId"].$get;

type SubmitRequest = InferRequestType<typeof submitEndpoint>["json"];
export type BlockAggregate = InferResponseType<typeof aggregateEndpoint, 200>;

/** Submit an anonymous learner response (poll/word-cloud). */
export const useSubmitBlockResponse = () =>
    useMutation<unknown, Error, SubmitRequest>({
        mutationFn: async (json) => {
            const res = await submitEndpoint({ json });
            if (!res.ok) throw new Error("Failed to submit response");
            return res.json();
        },
    });

/** Aggregated results for a block (counts for poll, word frequencies for cloud). */
export const useBlockAggregate = (blockId: string, enabled: boolean) =>
    useQuery({
        queryKey: ["lomda-v3-response-aggregate", blockId],
        enabled,
        queryFn: async () => {
            const res = await aggregateEndpoint({ param: { blockId } });
            if (!res.ok) throw new Error("Failed to load responses");
            return res.json();
        },
    });
